import React, { useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import routes, { defaultPath, signInPath } from './routes';
import './App.scss';
import { App as AntApp, ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { defaultTheme } from './theme/defaultTheme';

function App() {
  const element = useRoutes(routes);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(
    function () {
      if (location.pathname === defaultPath) {
        navigate(signInPath);
      }
    },
    [location, navigate],
  );

  return (
    <ConfigProvider theme={defaultTheme} locale={esES}>
      <AntApp>
        <div id={'App'}>{element}</div>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
